import React, { Fragment, PureComponent } from 'react';
import { RouteComponentProps } from 'react-router';
import { Container } from 'semantic-ui-react';
import { GAME_RUNS_QUERY } from '../../apollo';
import { RunTableCol, SortDir } from '../../types';
import { GameSegment } from '../HeaderSegments';
import RunTable from '../RunTable';
import Ad from '../Shared/Ad';

const cols: RunTableCol[] = [
  RunTableCol.Vods,
  RunTableCol.Event,
  RunTableCol.Category,
  RunTableCol.Runners,
  RunTableCol.Time,
  RunTableCol.WorldRecord,
  RunTableCol.Handicapped,
  RunTableCol.DevCommentary,
  RunTableCol.Race,
  RunTableCol.Tas,
];

interface MatchParams {
  id: string;
}

interface Props extends RouteComponentProps<MatchParams> {}

class GamePage extends PureComponent<Props> {
  public render() {
    const { match } = this.props;
    return (
      <Fragment>
        <GameSegment gameId={match.params.id} />
        <Container>
          <Ad key="GamePage" />
          <RunTable
            key={`game-${match.params.id}`}
            query={GAME_RUNS_QUERY}
            queryVars={{ game: match.params.id }}
            defaultSortCol={RunTableCol.Category}
            defaultSortDir={SortDir.Ascending}
            cols={cols}
          />
        </Container>
      </Fragment>
    );
  }
}

export default GamePage;
export { GamePage };
